import React from "react";
import '../Reportes.css';
import { Tabs, Button,  message, Icon, Spin } from "antd";
import { Redirect } from 'react-router';
import axios from "axios";
import { VerticalAlignBottomOutlined } from "@ant-design/icons";


var tiempoMensaje = 5;
let estado="OC";

class ReporteFormato extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            activeTab: "1",
            comboHidden: true,
            options: [],
            isLoadingDocumentos: false,
            isLoadingMateriales: false,
            isDescargando: false,
            redirect: false,
            documentos: [],
            materiales: [],
            nombreOple: [],
            selectedOption: [],
            selectedOptionObject: [],
            optionsMateriales: [],
            optionTodosLosDocumentos: [],
            porcentajeA: "",
            porcentajeU: "",
            estado:""
        };

    }
    
    downloadExcel = () => {

        this.state.estado =localStorage.getItem('ID_ESTADO_SELECCIONADO');
        if(this.state.estado == 'null' || this.state.estado == 'undifine'){
            this.state.estado='0'
            this.state.estado=parseInt(this.state.estado); 
          //  console.log("SELECCIONADO", this.state.estado);
       }
        this.setState({
            isDescargando: true
        });

        let data = JSON.stringify({
            idDetalleProceso: localStorage.getItem('ID_DETALLE_PROCESO'),
            idProceso: localStorage.getItem('ID_PROCESO_ELECTORAL'),
            idEstado: this.state.estado,
           // idClasificacionEleccion: this.state.selectedOptionObject[0].value,
            nombreEstado: localStorage.getItem('ESTADO'),
           // clasificacionEleccion: this.state.selectedOptionObject[0].label,
           // documentos: this.state.documentos,
           // materiales: this.state.materiales,
        })

        //console.log('Descargando reporte con los siguientes parametros: ', data)

        axios.post(
            `${localStorage.getItem('SERVERCENTRAL')}/descargaReporteDiscapacidad`, data, {
            headers: {
                'Authorization': localStorage.getItem('accessToken'),
                'Content-Type': 'application/json',
                Accept: "application/json",
            }
        })
            .then(resp => {
             //   console.log("RESPUESTA****", resp)
               // console.log("RESPUESTA1****", resp.data.entity.code)
                if (resp.data.entity.code === 200) {
                    this.setState({
                        isDescargando: false,
                        disabledFiltro: false,

                    });
                    //console.log("estado loc",localStorage.getItem('ESTADO') )
                    if(localStorage.getItem('ESTADO') !== 'null')
                    estado=localStorage.getItem('ESTADO');
                    var sampleArr = base64ToArrayBuffer(resp.data.entity.reporteDiscapacidad);
                    saveByteArray("Reporte_Formato_Discapacidad_"+ estado +".xlsx", sampleArr);

                } 
                else if (resp.data.entity.code == 403) {
                    localStorage.clear();
                    window.location = "/login"
                } 
                else {
                   // console.log("Error.downloadExcel: ", resp.data.entity.message)
                   // message.error(resp.data.entity.causa,tiempoMensaje);
                    //alert(resp.data.entity.causa)
                }
            }).catch(err => {
                //console.log("Error.downloadExcel: ", err)
                if (err.response != null && err.response.status == 403) {
                    localStorage.clear();
                    window.location = "/login"
                    return;
                }
                this.setState({
                    isDescargando: false,
                });
                message.error("Ocurrió un error al descargar el reporte, favor de intentar más tarde.",tiempoMensaje);
               // alert("Ocurrió un error al descargar el reporte, favor de intentar más tarde.")
            })


        function base64ToArrayBuffer(base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        }

        function saveByteArray(reportName, byte) {
            var blob = new Blob([byte], { type: "application/xlsx" });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            var fileName = reportName;
            link.download = fileName;
            link.click();
        }

    }


    render() {


        if (this.state.redirect) {
            return <Redirect push to="/reportes" />;
        }

        return (
            <div>

                <h1 className="titulo-reportes">Formato de personas con discapacidad </h1>
                 <br/>
                <div >
                  
                    <Button 
                    //disabled={!(this.state.selectedOptionObject.length > 0)} 
                    id="regresar"
                        onClick={this.downloadExcel}
                        className="descarga"
                        disabled={this.state.isDescargando !== false ? true : false}
                    >
                        <VerticalAlignBottomOutlined /> Descargar
          </Button>   <Icon type="info-circle" theme="filled" className="icono-info" /> <label className="texto-16-reportes">En formato .xls</label>
          {this.state.isDescargando !== false ? (<Spin size="large" />) : null}
                </div>
            <br/>
          <br/>
          <br/>
            </div>
        );
    }
}

export default ReporteFormato;